/**
 * Restricted-visibility chip vocabulary shared across the Customer
 * Settings V2 sections. `Staff Only` / `Admin Only` match the labels
 * already used on the Site / Site Group pages so the LeftNav rail and
 * section headers read consistently.
 *
 * Contains:
 * - adminOnlyChip, staffOnlyChip, accountingOnlyChip
 */

import React from 'react';

import StatusChip from '@sophocles/components/StatusChip';

export const adminOnlyChip = (t, key = 'siteSettings.adminOnly', label = 'Admin Only') => (
  <StatusChip color="info" label={t(key, label)} />
);
export const staffOnlyChip = (t, key = 'siteSettings.staffOnly', label = 'Staff Only') => (
  <StatusChip color="info" label={t(key, label)} />
);
export const accountingOnlyChip = (t, key = 'siteSettings.accountingOnly', label = 'Accounting Only') => (
  <StatusChip color="info" label={t(key, label)} />
);
